import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { DashboardService } from '../../service/dashboard.service';
import { NgxSpinnerService } from 'ngx-spinner';
import Swal from 'sweetalert2';
import { Utf8EncodingService } from 'src/app/md/service/utf8-encoding.service';
import { session } from 'src/environments/environment.session';
import { DarpanExportService } from '../../service/darpan-export.service';

@Component({
  selector: 'app-darpan-data-preview-and-push',
  templateUrl: './darpan-data-preview-and-push.component.html',
  styleUrls: ['./darpan-data-preview-and-push.component.css']
})
export class DarpanDataPreviewAndPushComponent implements OnInit {
  previewData: any[] = [];
  financialYears: string[] = [];
  totals: any = {};
  erpUser: any;
  b_acct_id: any;

  constructor(
    private router: Router,
    private dashboardService: DashboardService,
    private spinner: NgxSpinnerService,
    private utf8EncodingService: Utf8EncodingService,
    private darpanExportService: DarpanExportService
  ) { }

  ngOnInit(): void {
    this.erpUser = this.utf8EncodingService.decodeFromUtf8((session['erpUser'] as any));
    this.b_acct_id = this.erpUser?.b_acct_id ?? null;
    this.fetchPushData();
  }

  goBack() {
    this.router.navigate(['/acms/acms-index']);
  }

  fetchPushData() {
    if (!this.b_acct_id) {
      Swal.fire('Error', 'Account ID is missing', 'error');
      return;
    }

    this.spinner.show();
    this.dashboardService.getPreviewPushData({ b_acct_id: this.b_acct_id }).subscribe(
      (res: any) => {
        this.spinner.hide();
        if (res && !res.error) {
          this.previewData = res.finalData || [];
          this.financialYears = res.financialYears || [];
          this.calculateTotals();
          if (this.previewData.length === 0) {
            Swal.fire('Info', 'No data found to preview.', 'info');
          }
        } else {
          Swal.fire('Error', res.error || 'Failed to fetch preview data', 'error');
        }
      },
      (error: any) => {
        this.spinner.hide();
        console.error(error);
        Swal.fire('Error', 'Server error while fetching data', 'error');
      }
    );
  }

  pushData() {
    if (!this.b_acct_id) {
      Swal.fire('Error', 'Account ID is missing', 'error');
      return;
    }

    Swal.fire({
      title: 'Are you sure?',
      text: "You are about to push this data to the Darpan portal.",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, push it!'
    }).then((result) => {
      if (result.isConfirmed) {
        this.spinner.show();
        this.dashboardService.pushDataToDarpan({ b_acct_id: this.b_acct_id }).subscribe(
          (res: any) => {
            this.spinner.hide();
            if (res && !res.error) {
              const summary = res.summary;
              if (res.no_date_present) {
                Swal.fire(
                  'Warning',
                  res.summary,
                  'warning'
                )
              } else {
                Swal.fire(
                  'Pushed!',
                  `Data pushed successfully.\nSuccess: ${summary?.successCount || 0}, Fail: ${summary?.failCount || 0}`,
                  'success'
                ).then(() => {
                  this.router.navigate(['/acms/darpan-integration/pushed-data-log']);
                });
              }

            } else {
              Swal.fire('Warning', 'Push completed with errors. Please check the logs.', 'warning');
            }
          },
          (error) => {
            this.spinner.hide();
            console.error(error);
            Swal.fire('Error', 'Failed to push data to Darpan', 'error');
          }
        );
      }
    });
  }

  calculateTotals() {
    this.totals = {
      kpi1_data: 0, kpi2_data: 0, kpi3_data: 0, kpi4_data: 0, kpi5_data: 0, kpi6_data: 0
    };

    for (const item of this.previewData) {
      this.totals.kpi1_data += Number(item.kpi1_data) || 0;
      this.totals.kpi2_data += Number(item.kpi2_data) || 0;
      this.totals.kpi3_data += Number(item.kpi3_data) || 0;
      this.totals.kpi4_data += Number(item.kpi4_data) || 0;
      this.totals.kpi5_data += Number(item.kpi5_data) || 0;
      this.totals.kpi6_data += Number(item.kpi6_data) || 0;
    }
  }

  exportExcel() {
    this.darpanExportService.exportExcel(
      this.previewData,
      this.totals,
      this.financialYears,
      'Darpan_Integration_Preview_Data',
      'Darpan Integration Preview Data',
      false
    );
  }

  exportPDF() {
    this.darpanExportService.exportPDF(
      this.previewData,
      this.totals,
      this.financialYears,
      'darpan-integration-preview',
      'Darpan Integration Preview Data',
      false
    );
  }
}
